import { Selector } from 'components/OWForm/Inputs/Selector'
import { TOption } from 'components/OWForm/OWSelect'
import useFetchApi, { FetchingStatus } from 'hooks/useFetchApi/useFetchApi'
import { isNil } from 'lodash-es'
import { LocationSubDomainInfo } from 'models'
import { useCallback, useEffect, useMemo, useState } from 'react'
import cloudTenantService from 'Services/api/tenant.service'
import getEnv from 'utilities/getEnv'
import { getLocationLink } from 'utilities/getLocationLink'

export function LocationSwitcher() {
    const [selectedLoc, setSelectedLoc] = useState('')
    const [
        locations = [] as LocationSubDomainInfo[],
        fetchLocationDomains,
        status,
    ] = useFetchApi(cloudTenantService.getSubDomain)

    const loTenantID = getEnv('REACT_APP_LOCATION_TENANT_IDENTIFIER_ID')

    const handleOnSelect = useCallback((value: string) => {
        setSelectedLoc(value)
        var locationLink = getLocationLink(value)
        if (!isNil(locationLink)) window.open(locationLink, '_self')
    }, [])

    const options: TOption[] = useMemo(() => {
        return locations.map<TOption>((a) => ({
            label: a.name,
            value: a.subDomain,
        }))
    }, [locations])

    useEffect(() => {
        fetchLocationDomains()
    }, [fetchLocationDomains])

    useEffect(() => {
        if (locations && loTenantID) {
            const locSubDomain = locations.find(
                (a) => a.tenantIdentifierID === loTenantID,
            )
            setSelectedLoc(locSubDomain?.subDomain || '')
        }
        return () => {
            setSelectedLoc('')
        }
    }, [loTenantID, locations])

    return (
        <Selector
            fullWidth
            loading={status === FetchingStatus.LOADING}
            options={options}
            onChangeCallback={handleOnSelect}
            value={selectedLoc}
        />
    )
}
